import React, { FunctionComponent } from 'react';
import styles from './text-block-schema.module.scss';
import Arrow from '../../assets/images/cta-arrow.inline.svg';

export interface ITextBlockSchemaProps {
  text: string;
  hasArrow: boolean;
}

export const TextBlockSchema: FunctionComponent<ITextBlockSchemaProps> = ({
  text,
  hasArrow
}) => (
  <div className={styles.wrapper}>
    <span className={styles.text}>{text}</span>
    {hasArrow && (
      <div className={styles.arrowWrapper}>
        <Arrow className={styles.arrowBottom} />
      </div>
    )}
  </div>
);
